import {
  constructList,
  sortAndSliceList,
  appendGOATandCountryCodeToTitle,
  stripSpecialCharacterFromString,
} from 'shared/utils/pageMetadataUtils';
import { startCase } from 'shared/utils/startCase';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.getDesignerValueMetadata';

export const getDesignerValueMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  query,
}) => {
  const { groups = [], results = [] } = constructorResponse?.response || {};
  const designerValue: string = query?.designerValue;
  const designerValueWithStartCase: string = startCase(designerValue);
  const topLevelCategory: string =
    groups?.[0]?.group_id === 'sneakers'
      ? t(`${TP}.shoes`, 'shoes')
      : stripSpecialCharacterFromString(groups?.[0]?.group_id);
  const topLevelCategoryWithStartCase: string = startCase(topLevelCategory);

  const topTwoPTs = constructList({
    list: sortAndSliceList(results, 2),
    key: 'value',
  });

  const title = t(
    `${TP}.title`,
    'Buy {designerValueWithStartCase} {topLevelCategoryWithStartCase}. New Releases & Iconic Styles',
    {
      designerValueWithStartCase,
      topLevelCategoryWithStartCase,
    },
  );

  // single product
  if (topTwoPTs?.constructedListWithStartCase?.length === 1) {
    const descriptionSingleProduct = t(
      `${TP}.descriptionSingleProduct`,
      'Shop {topLevelCategory} designed by {designerValueWithStartCase} on GOAT. From the {productA}. Authenticity assured.',
      {
        topLevelCategory,
        designerValueWithStartCase,
        productA: topTwoPTs?.constructedListWithStartCase[0],
      },
    );

    return {
      pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
      pageDescription: pageDescription || descriptionSingleProduct,
    };
  }

  // with 2 products
  if (topTwoPTs?.constructedListWithStartCase?.length >= 1) {
    const constructedList = topTwoPTs.constructedListWithStartCase;
    const descriptionWithConstructedList = t(
      `${TP}.descriptionWithConstructedList`,
      'Shop {topLevelCategory} designed by {designerValueWithStartCase} on GOAT. From the {productA} to the {productB}. Authenticity assured.',
      {
        topLevelCategory,
        designerValueWithStartCase,
        productA: constructedList[0],
        productB: constructedList[constructedList.length - 1],
      },
    );

    return {
      pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
      pageDescription: pageDescription || descriptionWithConstructedList,
    };
  }

  // default
  const description = t(
    `${TP}.description`,
    'Shop {topLevelCategory} designed by {designerValueWithStartCase} on GOAT. Authenticity assured.',
    {
      topLevelCategory,
      designerValueWithStartCase,
    },
  );

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
